module.exports = __webpack_public_path__ + "img/img_32.b3a1d845.png";